export default __webpack_public_path__ + "text-label040662.png";